<template>
  <div>
    <div v-if="uploadedFilePath && !uploading">
      <button @click="deleteFile" class="btn btn-danger">{{ 'Delete' | translate }} {{ 'file' | translate }}</button>
      <a :href="url" target="_blank" class="ms-3">
        {{ 'Open file' | translate }}
      </a>
    </div>
    <div v-else>
      <div v-if="uploading">
        <span>{{ 'Uploading' | translate }}:</span>
        <div class="progress">
          <div
            class="progress-bar progress-bar-striped progress-bar-animated"
            role="progressbar"
            :style="`width: ${status}%`"
            :aria-valuenow="status"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
      </div>
      <div class="custom-file" v-else>
        <input ref="file" type="file" class="form-control" @change="submit" :accept="acceptedFileTypes.join(', ')" />
        <small v-if="hint" class="text-muted">{{ hint }}</small>
        <small class="text-muted">{{ acceptedFileExtensions }}</small>
      </div>
    </div>
  </div>
</template>

<script>
import route from './../routes.js'
import _ from 'lodash'

export default {
  props: ['filePath', 'context', 'acceptedType', 'hint'],
  data() {
    return {
      uploading: false,
      uploadFinished: false,
      status: 0,
      uploadedFilePath: this.filePath || null,
    }
  },
  computed: {
    url() {
      let file = _.get(this, 'uploadedFilePath', null)
      if (file) {
        return `https://skyier-bucket.s3.eu-west-1.amazonaws.com/${file}`
      }
      return null
    },
    acceptedFileExtensions() {
      if (this.acceptedType === 'email') {
        return 'PDF, ZIP'
      }

      if (this.acceptedType === 'audio') {
        return 'MP3, M4A'
      }

      return 'PDF, DOC, DOCX, XLS, XLSX, ZIP'
    },
    acceptedFileTypes() {
      if (this.acceptedType === 'email') {
        return ['application/zip', 'application/x-zip-compressed', 'multipart/x-zip', 'application/pdf']
      }

      if (this.acceptedType === 'audio') {
        return ['audio/mp3', 'audio/mpeg', 'audio/x-m4a']
      }

      return [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/zip',
        'application/octet-stream',
        'application/x-zip-compressed',
        'multipart/x-zip',
      ]
    },
  },
  methods: {
    updateProgress(status) {
      this.status = status
    },
    deleteFile() {
      axios
        .post(route.images().delete, {
          path: this.uploadedFilePath,
          context: this.context,
        })
        .then((response) => {
          this.uploadedFilePath = null
          this.$emit('fileDeleted')
        })
        .catch(this.handleError)
    },
    handleError(error) {
      if (error.response && error.response.status === 419) {
        this.$root.$emit('flash', this.$t('Your session has expired - please reload'), 'warning')
      } else {
        iziToast.error({
          title: 'Error',
          message: this.$t('Something went wrong'),
          position: 'bottomLeft',
        })
        console.error(error)
      }
    },
    upload(updateProgress) {
      let filename = _.snakeCase(_.deburr(this.file.name.split('.').slice(0, -1).join('.')))
      axios
        .post(route.images().initiateUpload, {
          extension: this.fileExtension,
          filename,
        })
        .then((response) => {
          let config = {
            headers: {
              'Content-Type': this.file.type,
            },
            transformRequest: [
              (data, headers) => {
                delete headers.common.Authorization
                delete headers.common['X-CSRF-TOKEN']
                return data
              },
            ],
            onUploadProgress(progressEvent) {
              updateProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total))
            },
          }
          this.uploadedFilePath = response.data.download
          return axios.put(response.data.upload, this.file, config)
        })
        .then((response) => {
          this.uploading = false
          this.$emit('uploadCompleted', this.uploadedFilePath)
        })
        .catch((error) => {
          this.uploading = false
          this.handleError(error)
        })
    },
    submit(e) {
      this.file = this.$refs['file'].files[0]
      this.fileExtension = this.file.name.split('.').pop()

      if (this.file) {
        this.uploading = true
        if (_.includes(this.acceptedFileTypes, this.file.type)) {
          this.upload(this.updateProgress)
        } else {
          this.uploading = false
          iziToast.error({
            title: this.$t('Error'),
            message: this.$t('Bad file extension'),
            position: 'bottomLeft',
          })
        }
      }
    },
  },
}
</script>
